<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel" :width="850"
           style="max-height:80%; over-flow:auto"
           @on-visible-change="visibleChange"
           class="long-modal"

    >

      <h3 slot="header" class="modal-header" style="text-align: left">{{header}}</h3>


      <div style="text-align: right">
        <Button type="primary" :loading="bLoading" @click.stop="exportBillDetailList" v-p="{api:'proprietor/exportBillDetailList'}">导出</Button>
      </div>
      <div  class="mb32" v-if="billDetail">
        <h3>结算账单明细</h3>
        <div class="mb8">结算周期: <span class="text-red">{{billDetail.balancePeriod}}</span></div>

          <!--<Table :columns="columns1" :data="billDetail.balanceBillList" height="300" class="mb16" ></Table>-->
        <table-list
          title="" :columns="columns1" :data="billDetail.balanceBillList"
          :loading="loading"
          :total="total"
          :current="current"
          @change-page="changePage"
        ></table-list>


        <div>
          <span class="mr20"> 账单数：<span class="text-red">{{billDetail.billNum}}</span></span>
          <span class="mr20">账单金额合计：<span class="text-red">{{billDetail.billAmountTotal}}</span></span>
          <span class="mr20">平台管理费率： <span class="text-red">{{billDetail.manageRate}}</span></span>
          <span>业主应结算金额：<span class="text-red">{{billDetail.balanceMoney}}</span></span>
        </div>
      </div>
      <div>
        <h3>预存保证金明细</h3>
        <Table :columns="columns2" :data="depositDetail" class="mb16"></Table>
        <div class="text-red">本次业主实际结算金额 = 本次业主应结算金额 - 本次扣存保证金</div>
      </div>
      <div style="margin-bottom: 50px;margin-top: 20px;">
        <h3>付款明细</h3>
        <Table :columns="columns3" :data="paymentDetail" class="mb16"></Table>


      </div>

      <div slot="footer">
        <span v-if="!control || !control.isRead">
        <span v-if="balanceStatus===0">
          <Button type="primary" @click.stop="confirm">确认无误</Button>
          <Button type="error" @click.stop="reject">不通过</Button>
        </span>

        <span v-if="balanceStatus===1">
          <Button type="primary" @click.stop="passBalance">通过</Button>
          <Button type="error" @click.stop="reject">驳回</Button>

        </span>
        <span v-if="balanceStatus===2">
          <Button type="error" @click.stop="repay">重新付款</Button>
        </span>
        </span>
        <Button @click.stop="isShow=false">取消</Button>
      </div>

      <reject-modal :n="rN"
                    :balanceFid="balanceFid"
                    @done="close"
                    :balanceStatus="balanceStatus"
      ></reject-modal>
      <bill-detail :n="bN" :receiptNumber="receiptNumber" :balanceFid="balanceFid">

      </bill-detail>
    </Modal>
  </div>


</template>
<script>
  import TableList from "components/TableList/index";
  import {balanceDetail} from "../../../api/settleManage";
  import {confirmBalance, rejectBalance, passBalance, repay, exportBillDetailList} from "../../../api/settleManage";
  import RejectModal from './RejectModal'
  import BillDetail from './BillDetail'


  export default {
    name: "",
    components: {
      RejectModal,
      BillDetail,
      TableList
    },
    props: {
      n: {
        type: Number,
        default: 100
      },
      balanceFid: {
        type: String,
        default: ''
      },
      balanceStatus: {
        type: Number,
        default: 0
      },
      control: {
        type: Object,
        default: null
      }
    },
    computed: {
      header() {
        // if (this.balanceStatus === 0) {
        //   return '查看结算单'
        //
        // }
        if (this.control && this.control.isRead) {
          return '查看结算单'

        }
        if (this.balanceStatus === 0 || this.balanceStatus === 1) {
          return '确认结算单'
        }
        if (this.balanceStatus === 2) {
          return "财务结算单 "

        }
        return ''

      }

    },
    watch: {

      n() {
        this.clearData()
        this.$nextTick(()=>{
          this.balanceDetail()
          this.isShow = true
        })
      }
    },
    created() {
      // this.balanceDetail()

    },

    data() {
      return {
        receiptNumber:'',
        bLoading: false,
        bN: 0,
        rN: 0,
        remark: '',
        loading: false,
        isShow: false,
        total:0,
        current:1,
        page:1,
        billDetail: null,
        depositDetail: [],
        paymentDetail: [],
        columns1: [
          {
            title: "类型",
            key: "billSourceName",
            align: "center",
            // width:80,
          },
          {
            title: "帐单编号",
            key: "billNumber",
            align: "center",
            render:(h,params)=>{
              if(params.row['billSource']===2){
                return h('a',{
                  on:{
                    click:()=>{
                      this.receiptNumber=params.row['billNumber']
                      this.bN++
                    }
                  }

                },params.row['billNumber'])
              }
              else {
                return h('span',{},params.row['billNumber'])
              }
            }
          },
          {
            title: "合同号",
            key: "contractCode",
            align: "center",
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
          },
          // {
          //   title: "费用项",
          //   key: "costItemName",
          //   align: "center",
          // },
          {
            title: "收付款方式",
            key: "receiptMethodName",
            align: "center",
          },
          {
            title: "收付款日期",
            key: "payDate",
            align: "center",
          },
          {
            title: "金额",
            key: "money",
            align: "center",
            // width:150,
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }


              },params.row['money'])

            },
          },

        ],
        columns2: [
          {
            title: "保证金基线",
            key: "baseCashDeposit",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }


              },params.row['baseCashDeposit'])

            },

          },
          {
            title: "保证金余额",
            key: "originCashDeposit",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }


              },params.row['originCashDeposit'])

            },
          },
          {
            title: "保证金缺口",
            key: "depositGap",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }


              },params.row['depositGap'])

            },
          },
          {
            title: "本次扣存保证金",
            key: "depositDeduct",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }


              },params.row['depositDeduct'])

            },
          },
          {
            title: "本次实际业主结算金额",
            key: "paymentMoney",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }
              },params.row['paymentMoney'])

            },
          },

        ],
        columns3: [
          {
            title: "付款单号",
            key: "paymentCode",
            align: "center",
          },

          {
            title: "付款金额",
            key: "money",
            align: "center",
            // width:100,
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'150px',
                  textAlign:'right'
                }


              },params.row['money'])

            },
          },

          {
            title: "户名",
            key: "proprietorName",
            align: "center",
          },

          {
            title: "开户行",
            key: "proprietorBankName",
            align: "center",
          },

          {
            title: "银行账号",
            key: "proprietorAccount",
            align: "center",
          },

          {
            title: "提交日期",
            key: "submitDate",
            align: "center",
            // width: 140
          },

          {
            title: "付款日期",
            key: "payDate",
            align: "center",
            // width: 140
          },
          {
            title: "付款状态",
            key: "payStatusName",
            align: "center",
          },
        ]

      }
    },
    methods: {
      visibleChange(value) {
        if (!value) {
          this.control.isRead = false
        }
      },
      exportBillDetailList() {
        if (!this.balanceFid) {
          return
        }
        let params = {
          balanceFid: this.balanceFid

        }
        this.bLoading = true
        exportBillDetailList(params).then(res => {
          let fileName = res.headers.filename || 'excel.xls'
          let blob = new Blob([res.data])

          let url = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.buttonloading = false

        }).catch(error => {
        }).finally(() => {
          this.bLoading = false
        })

      },
      close() {
        this.$emit('refresh')
        this.isShow = false
      },
      reject() {
        this.rN++
      },
      clearData() {
        this.billDetail = null
        this.depositDetail = []
        this.paymentDetail = []
      },
      repay() {
        this.$Modal.confirm({
          title: '付款异常处理',
          content: '<p>继续操作将重新生成付款单并执行打款流程，请问是否继续？</p>',
          onOk: () => {
            repay({balanceFid: this.balanceFid}).then(res => {
              this.$Message.success('操作成功')
            }).catch(error => {

            }).finally(() => {
              this.$emit('refresh')
              this.isShow = false

            })
            // this.dataList.splice(index, 1)
          }
        })

      },
      passBalance() {
        this.$Modal.confirm({
          title: '结算单审核',
          content: '<p>确认后将提交财务付款，此操作不可逆。</p>',
          onOk: () => {
            passBalance({balanceFid: this.balanceFid}).then(res => {
              this.$Message.success('操作成功')

            }).catch(error => {

            }).finally(() => {
              this.$emit('refresh')
              this.isShow = false

            })
            // this.dataList.splice(index, 1)
          }
        })

      },
      confirm() {
        this.$Modal.confirm({
          title: '结算单确认',
          content: '<p>是否确认结算帐单和金额无误？</p>',
          onOk: () => {
            confirmBalance({balanceFid: this.balanceFid}).then(res => {
              this.$Message.success('操作成功')
            }).catch(error => {

            }).finally(() => {
              this.$emit('refresh')
              this.isShow = false
            })
            // this.dataList.splice(index, 1)
          }
        })

      },
      balanceDetail() {
        if (!this.balanceFid) {
          return
        }
        balanceDetail({balanceFid: this.balanceFid,
          page:this.page,
          limit:10}).then(res => {
          if (!res.data) {
            return

          }
          this.billDetail = res.data.billDetail
          this.total=res.data.billDetail.billCount
          this.depositDetail = res.data.depositDetail
          this.paymentDetail = res.data.paymentDetail
        }).catch(error => {
        })

      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {

      },
      cancel() {

      },
      changePage(n){
        this.page=n
        this.current=n
        this.balanceDetail()
      }
    }

  }
</script>

<style scoped>
  h3 {
    text-align: center;
    margin-bottom: 10px;
  }

  .mr20 {
    margin-right: 20px;
  }

</style>
